// extracted by mini-css-extract-plugin
module.exports = {"Title":"List__Title_3J_NO","Items":"List__Items_tgTTm grid","Year":"List__Year_2BY44","ItemsByYear":"List__ItemsByYear_26CnQ","Filters":"List__Filters_HilxT"};